import { grabRepairDetails } from './repairRequest';
import Compress from 'compress.js';
import axios from 'axios';
let compressedImage = '';
let compressedImage02 = '';

const retrieveWarranties = API_URL.retrieveWarranties;
const saveWarranties = API_URL.saveWarranties;

export const displayWarrantyButtons = () => {
  document.addEventListener('DOMContentLoaded', async function () {
    const email = document.querySelector('.logged-in').dataset.email;
    if (email != null && email.length > 0) {
      formatWarrantyButtons();
      const request = {
        hmac: document.querySelector('.logged-in').dataset.hmac,
        email: email,
        customerId: document.querySelector('.logged-in').dataset.customerId,
      };

      try {
        const response = await axios.post(
          retrieveWarranties,
          JSON.stringify(request)
        );
        const warrantyButtons = document.querySelectorAll('.warranty-button');
        warrantyButtons.forEach((button) => {
          if (response.data.length > 0) {
            for (let key in response.data) {
              if (
                button.dataset.sku == response.data[key].ProductSKU__c &&
                button.dataset.orderNumber == response.data[key].OrderID__c
              ) {
                checkQuantity(button, response.data, key);
              } else {
                button.style.display = 'block';
              }
            }
          } else {
            button.style.display = 'block';
          }
        });
      } catch (error) {
        console.log(error);
      }
    }
  });
};

export const prefillWarrantyInfo = () => {
  document.addEventListener('DOMContentLoaded', function () {
    submitWarrantyEvent();
    if (localStorage.getItem('email')) {
      document.querySelector('input[name="firstName"]').value =
        localStorage.getItem('firstName');
      document.querySelector('input[name="lastName"]').value =
        localStorage.getItem('lastName');
      document.querySelector('input[name="productName"]').value =
        localStorage.getItem('productName');
      document.querySelector('input[name="productColor"]').value =
        localStorage.getItem('productColor');
      document.querySelector('input[name="storeType"]').value =
        localStorage.getItem('purchaseLocation');
      document.querySelector('input[name="email"]').value =
        localStorage.getItem('email');
      document.querySelector('input[name="orderId"]').value =
        localStorage.getItem('orderId');
      document.querySelector('input[name="orderNumber"]').value =
        localStorage.getItem('orderNumber');
      document.querySelector('input[name="sku"]').value =
        localStorage.getItem('sku');
      document.querySelector('input[name="purchaseDate"]').value =
        localStorage.getItem('purchaseDate');
    }
  });
};

export const submitWarrantyEvent = () => {
  document
    .getElementById('l-warranty__register-warranty-form')
    .addEventListener('submit', function (e) {
      e.preventDefault();
      document.getElementById('warranty-submit').disabled = true;
      document.getElementById('warranty-submit').innerHTML =
        '登録 <i class="fas fa-spinner fa-spin"></i>';

      var request = JSON.stringify({
        email: document.querySelector('input[name="email"]').value,
        orderNumber: document.querySelector('input[name="orderNumber"]').value,
        orderId: document.querySelector('input[name="orderId"]').value,
        firstName: document.querySelector('input[name="firstName"]').value,
        lastName: document.querySelector('input[name="lastName"]').value,
        birthday: document.querySelector('input[name="birthday"]').value,
        gender: document.querySelector('select[name="gender"] option:checked')
          ? document.querySelector('select[name="gender"] option:checked').text
          : document.querySelector('input[name="gender"]').value,
        productName: document.querySelector('input[name="productName"]').value,
        productColor: document.querySelector('input[name="productColor"]')
          .value,
        serialNumber: document.querySelector('input[name="serialNumber"]')
          .value,
        sku: document.querySelector('input[name="sku"]').value,
        // storeName: document.querySelector('input[name="storeName"]').value,
        storeType: document.querySelector('input[name="storeType"]').value,
        purchaseDate: document.querySelector('input[name="purchaseDate"]')
          .value,
        hmac: document.querySelector('.logged-in').dataset.hmac,
        customerId: document.querySelector('.logged-in').dataset.customerId,
      });

      axios
        .post(saveWarranties, request)
        .then(function (response) {
          if (response.data === 'save success') {
            document.querySelector('.submit-fail-msg').style.display = 'none';
            setTimeout(function () {
              window.location.href = '/account';
            }, 1500);
          } else {
            document.getElementById('warranty-submit').innerHTML = '登録';
            document.querySelector('.submit-fail-msg').style.display = 'block';
          }
        })
        .catch(function (error) {
          if (error.response.data === 'save success') {
            document.querySelector('.submit-fail-msg').style.display = 'none';
            setTimeout(function () {
              window.location.href = '/account';
            }, 3000);
          } else {
            document.getElementById('warranty-submit').innerHTML = '登録';
            var errorMsg =
              error.response.data === 'Warranty already exists'
                ? 'シリアルナンバーが既に登録されています。ご確認ください。'
                : '保証登録は既に完了している可能性がございます。お手数おかけいたしますが、15分程度経ってから再度ご確認くださいませ。';
            document.querySelector('.submit-fail-msg').innerHTML = errorMsg;
            document.querySelector('.submit-fail-msg').style.display = 'block';
            document.getElementById('warranty-submit').disabled = false;
          }
        });
    });
};

export const showAlertMessage = () => {
  document.addEventListener('DOMContentLoaded', () => {
    const ref = document.referrer;
    const alertMessage = document.querySelector('.warrantyalert-label');
    if (
      ref.indexOf('/account?view=register_warranty') != -1 ||
      ref.indexOf('/account?view=ext_warranty') != -1
    ) {
      if (alertMessage) {
        alertMessage.classList.remove('u-hidden');
      }
    }
  });
};

export const externalWarrantyClickEvents = () => {
  document.addEventListener('DOMContentLoaded', function () {
    compressImage();

    clearPurchaseDate();
    clearStoreName();
    clearStoreNameDropdown();
    clearUseDate();
    clearPhotoUpload();
    clearPhotoUpload02();
    clearExchangeStoreNameDropDown();

    requireOrderNumber();
    displayQuantity(
      document.querySelector('select[name="purchaseQuantity"]')
        .selectedOptions[0].value
    );

    document
      .querySelector('select[name="storeType"]')
      .addEventListener('change', function () {
        const storeType = document.querySelector(
          'select[name="storeType"]'
        ).value;

        if (
          storeType === 'online' ||
          storeType === 'rakuten' ||
          storeType === 'amazon'
        ) {
          clearPurchaseDate();
          clearStoreName();
          clearStoreNameDropdown();
          clearUseDate();
          clearPhotoUpload();
          clearPhotoUpload02();
          requireOrderNumber();
          clearExchangeStoreNameDropDown();
        } else if (storeType === 'department_store') {
          clearOrderNumber();
          clearPhotoUpload();
          clearPhotoUpload02();
          clearStoreNameDropdown();
          clearUseDate();
          requireStoreName();
          requirePurchaseDate();
          requirePhoto();
          clearExchangeStoreNameDropDown();
        } else if (storeType === 'direct') {
          clearOrderNumber();
          clearPhotoUpload();
          clearPhotoUpload02();
          clearStoreName();
          clearUseDate();
          requireStoreNameDropdown();
          requirePurchaseDate();
          requirePhoto();
          clearExchangeStoreNameDropDown();
        } else if (storeType === 'rakuten_fashion') {
          clearOrderNumber();
          clearPhotoUpload();
          clearPhotoUpload02();
          clearStoreName();
          clearUseDate();
          requireOrderNumber();
          requirePurchaseDate();
          requirePhoto02();
          clearExchangeStoreNameDropDown();
        } else if (storeType === 'zozotown') {
          clearOrderNumber();
          clearPhotoUpload();
          clearPhotoUpload02();
          clearStoreName();
          clearUseDate();
          requireOrderNumber();
          requirePurchaseDate();
          requirePhoto02();
          clearExchangeStoreNameDropDown();
        } else if (storeType === 'giltorgladd') {
          clearOrderNumber();
          clearPhotoUpload();
          clearPhotoUpload02();
          clearStoreName();
          clearUseDate();
          requirePurchaseDate();
          requirePhoto02();
          clearExchangeStoreNameDropDown();
        } else if (storeType === 'gift') {
          clearOrderNumber();
          clearPurchaseDate();
          clearStoreName();
          clearStoreNameDropdown();
          clearPhotoUpload();
          clearPhotoUpload02();
          requireUseDate();
          clearExchangeStoreNameDropDown();
        } else if (storeType === 'exchange') {
          clearOrderNumber();
          clearPurchaseDate();
          clearStoreName();
          clearStoreNameDropdown();
          clearPhotoUpload02();
          requireUseDate();
          requireExchangeStoreNameDropDown();
        }
      });

    document
      .querySelector('select[name="purchaseQuantity"]')
      .addEventListener('change', function () {
        displayQuantity(
          document.querySelector('select[name="purchaseQuantity"]')
            .selectedOptions[0].value
        );
      });

    document
      .getElementById('l-ext-warranty-form')
      .addEventListener('submit', function (e) {
        e.preventDefault();
        submitExternalWarranty();
      });

    // document.getElementById('storeNameDropdown').addEventListener('change', function() {
    //     if (document.getElementById('storeNameDropdown').value === 'ミラノ') {
    //         requirePhoto();
    //     } else {
    //         clearPhotoUpload();
    //     }
    // });
  });
};

export const formatWarrantyPage = () => {
  document.addEventListener('DOMContentLoaded', () => {
    const email = document
      .querySelector('.logged-in')
      .getAttribute('data-email');
    if (email != null && email.length > 0) {
      const request = JSON.stringify({
        hmac: `${document
          .querySelector('.logged-in')
          .getAttribute('data-hmac')}`,
        email: `${email}`,
        customerId: `${document
          .querySelector('.logged-in')
          .getAttribute('data-customer-id')}`,
      });

      axios
        .post(retrieveWarranties, request)
        .then((response) => {
          const data = response.data;
          if (data.length > 0) {
            const sortedArray = [];
            for (const key in data) {
              sortedArray.push(data[key]);
            }
            for (const key in sortedArray) {
              sortedArray[key].Register_date__c =
                sortedArray[key].Register_date__c.split('+')[0];
            }
            sortedArray.sort(function (a, b) {
              return (
                new Date(b.Register_date__c) - new Date(a.Register_date__c)
              );
            });
            let template = '';
            for (const key in sortedArray) {
              template += `<div class="Table__Item">
                <div class="Table--Segments">
                  <div class="Table--Segment">
                    <div id="product-name" class="Table--Segment__Header ${
                      sortedArray[key].ProductName__c == null
                        ? 'Table--Segment__Header-Centered'
                        : ''
                    }">${
                      sortedArray[key].ProductName__c == null
                        ? sortedArray[key].ProductSKU__c
                        : sortedArray[key].ProductName__c
                    }</div>
                    <div id="product-color" class="Table--Segment__Subheader">${
                      sortedArray[key].ProductColor__c == null
                        ? ''
                        : sortedArray[key].ProductColor__c
                    }</div>
                  </div>
                  <div class="Table--Segment">
                    <p id="serial-number">${
                      sortedArray[key].SerialNumber__c
                    }</p>
                  </div>
                  <div class="Table--Segment">
                    <span class="expand-item">+</span>
                  </div>
                </div>
                <div class="Table--Details">
                  <div class="Table--Details__Box">
                    <div class="Field" id="location">ご購入店舗 <span>${
                      sortedArray[key].Store__c
                    }</span></div>
                    <div class="Field" id="date">ご購入日<span>${
                      sortedArray[key].Parchase_date__c == null
                        ? '-'
                        : sortedArray[key].Parchase_date__c.split('T')[0]
                            .split('-')
                            .join('/')
                    }</span></div>
                    <div class="Field" id="date">${
                      sortedArray[key].Store__c == 'ギフト' ||
                      sortedArray[key].Store__c == '交換品'
                        ? 'ご使用開始日'
                        : '保証登録日'
                    }<span>${sortedArray[key].Register_date__c.split('T')[0]
                      .split('-')
                      .join('/')}</span></div>
                    <div class="Field" id="order-id">注文番号 <span>${
                      sortedArray[key].OrderID__c == null
                        ? '-'
                        : sortedArray[key].OrderID__c
                    }</span></div>
                  </div>
                  <div class="c-order__button c-repair_button"><a href="/account?view=repair_request">修理依頼をする</a></div>
                </div>
              </div><!-- /.Table__Item -->`;
            }
            document
              .querySelector('.Table__Items')
              .insertAdjacentHTML('beforeend', template);
            // grabRepairDetails();
            const repairLinks = Array.from(
              document.querySelectorAll(
                'a[href="/account?view=repair_request"]'
              )
            );
            if (repairLinks) {
              repairLinks.forEach((repairLink) => {
                repairLink.addEventListener('click', (e) => {
                  e.preventDefault();
                  const details = e.currentTarget.closest('.Table__Item');
                  localStorage.setItem(
                    'serial-number',
                    details.querySelector('#serial-number').textContent
                  );
                  window.location.href = '/account?view=repair_request';
                });
              });
            }
            openFirstTab();
          } else {
            document.querySelector('#empty-warranty-msg').style.display =
              'block';
          }
        })
        .catch((error) => {
          console.log(error);
        });
    }
    warrantyClickEvent();
  });
};

const warrantyClickEvent = () => {
  document.addEventListener('click', function (e) {
    const expandItem = e.target.closest('.expand-item');
    if (expandItem) {
      const tableItem = expandItem.closest('.Table__Item');
      const tableDetails = tableItem.querySelector('.Table--Details');
      const expandText = expandItem.textContent;
      if (expandText === '+') {
        tableDetails.style.display = 'block';
        expandItem.textContent = '-';
        expandItem.classList.add('open');
      } else {
        tableDetails.style.display = 'none';
        expandItem.textContent = '+';
        expandItem.classList.remove('open');
      }
    }
  });
};

const formatWarrantyButtons = () => {
  let warrantyButtons = Array.from(
    document.querySelectorAll('.warranty-button')
  );
  warrantyButtons.forEach((button) => {
    button.addEventListener('click', function (e) {
      e.stopPropagation();
      const target = e.currentTarget;
      const user = document.getElementById('customer-data');
      localStorage.setItem('orderId', target.dataset.orderId);
      localStorage.setItem('orderNumber', target.dataset.orderNumber);
      localStorage.setItem('purchaseDate', target.dataset.createdAt);
      localStorage.setItem('sku', target.dataset.sku);
      localStorage.setItem('purchaseLocation', target.dataset.purchaseLocation);
      localStorage.setItem('firstName', user.dataset.firstName);
      localStorage.setItem('lastName', user.dataset.lastName);
      localStorage.setItem('productName', target.dataset.productName);
      localStorage.setItem('productColor', target.dataset.productColor);
      localStorage.setItem('email', user.dataset.email);
      window.location.href = '/account?view=register_warranty';
    });
  });
};

const checkQuantity = (button, response, itemKey) => {
  const sku = response[itemKey].ProductSKU__c;
  const orderNumber = response[itemKey].OrderID__c;
  const sameButtons_phone = Array.from(
    document.querySelectorAll(
      `[data-sku="${sku}"][data-order-number="${orderNumber}"].phone-button`
    )
  );
  const sameButtons_pc = Array.from(
    document.querySelectorAll(
      `[data-sku="${sku}"][data-order-number="${orderNumber}"].pc-button`
    )
  );

  let quantity = 0;
  for (const key in response) {
    if (
      response[key].ProductSKU__c == sku &&
      response[key].OrderID__c == orderNumber
    ) {
      quantity += 1;
    }
  }

  if (sameButtons_pc && sameButtons_pc.length) {
    for (let i = 0; i < sameButtons_pc.length; i++) {
      if (quantity >= i + 1) {
        sameButtons_pc[i].disabled = true;
        sameButtons_pc[i].classList.add('warranty-button-disabled');
        sameButtons_pc[i].textContent = '保証登録済';
        sameButtons_pc[i].style.display = 'block';
      }
    }
  }

  if (sameButtons_phone && sameButtons_phone.length) {
    for (let i = 0; i < sameButtons_phone.length; i++) {
      if (quantity >= i + 1) {
        sameButtons_phone[i].disabled = true;
        sameButtons_phone[i].classList.add('warranty-button-disabled');
        sameButtons_phone[i].textContent = '保証登録済';
        sameButtons_phone[i].style.display = 'block';
      }
    }
  }
};

const submitExternalWarranty = () => {
  document.querySelector('#warranty-submit').innerHTML =
    '登録 <i class="fa fa-spinner fa-spin"></i>';
  const warranties = formatWarrantyArray();
  const formData = new FormData();
  let n = 1;
  for (const w of warranties) {
    formData.append('sku' + n, w.sku);
    formData.append('serialNumber' + n, w.serialNumber);
    n++;
  }
  formData.append('warrantyCount', warranties.length);
  formData.append('email', document.querySelector('input[name="email"]').value);
  formData.append(
    'firstName',
    encodeURI(document.querySelector('input[name="firstName"]').value)
  );
  formData.append(
    'lastName',
    encodeURI(document.querySelector('input[name="lastName"]').value)
  );
  formData.append(
    'orderNumber',
    document.querySelector('input[name="orderNumber"]').value
  );
  formData.append(
    'storeName',
    document.querySelector('select[name="storeType"]').value === 'direct'
      ? encodeURI(
          document.querySelector(
            'select[name="storeNameDropdown"] option:checked'
          ).text
        )
      : encodeURI(document.querySelector('input[name="storeName"]').value)
  );
  formData.append(
    'exchangeStoreName',
    document.querySelector('select[name="storeType"]').value === 'exchange'
      ? encodeURI(
          document.querySelector(
            'select[name="exchangeStoreNameDropdown"] option:checked'
          ).text
        )
      : ''
  );
  formData.append(
    'storeType',
    encodeURI(
      document.querySelector('select[name="storeType"]').selectedOptions[0].text
    )
  );
  formData.append(
    'purchaseDate',
    document.querySelector('input[name="purchaseDate"]').value
  );
  formData.append(
    'useStartDate',
    document.querySelector('input[name="useStartDate"]').value
  );
  formData.append(
    'birthday',
    document.querySelector('input[name="birthday"]').value
  );
  formData.append(
    'gender',
    document.querySelector('select[name="gender"] option:checked')
      ? encodeURI(
          document.querySelector('select[name="gender"] option:checked').text
        )
      : encodeURI(document.querySelector('input[name="gender"]').value)
  );
  formData.append(
    'customerId',
    document.querySelector('.logged-in').dataset.customerId
  );
  formData.append('hmac', document.querySelector('.logged-in').dataset.hmac);

  if (compressedImage) {
    formData.append('file', compressedImage);
  } else if (compressedImage02) {
    formData.append('file', compressedImage02);
  }

  axios
    .post(API_URL.saveExternalWarranties, formData)
    .then((response) => {
      if (response.status === 200) {
        document.querySelector('.submit-fail-msg').style.display = 'none';
        window.location.href = '/account?view=warranty';
      } else {
        document.querySelector('#warranty-submit').innerHTML = '登録';
        document.querySelector('.submit-fail-msg').innerHTML = response.data;
        document.querySelector('.submit-fail-msg').style.display = 'block';
      }
    })
    .catch((error) => {
      document.querySelector('#warranty-submit').innerHTML = '登録';
      document.querySelector('.submit-fail-msg').innerHTML =
        error.response.data;
      document.querySelector('.submit-fail-msg').style.display = 'block';
    });
};

const formatWarrantyArray = () => {
  const warranties = [
    {
      sku: encodeURI(document.querySelector('input[name="sku1"]').value),
      serialNumber: document.querySelector('input[name="serialNumber1"]').value,
    },
    {
      sku: encodeURI(document.querySelector('input[name="sku2"]').value),
      serialNumber: document.querySelector('input[name="serialNumber2"]').value,
    },
    {
      sku: encodeURI(document.querySelector('input[name="sku3"]').value),
      serialNumber: document.querySelector('input[name="serialNumber3"]').value,
    },
    {
      sku: encodeURI(document.querySelector('input[name="sku4"]').value),
      serialNumber: document.querySelector('input[name="serialNumber4"]').value,
    },
    {
      sku: encodeURI(document.querySelector('input[name="sku5"]').value),
      serialNumber: document.querySelector('input[name="serialNumber5"]').value,
    },
  ];
  const filteredWarranties = warranties.filter(function (e) {
    return e.sku !== '' && e.serialNumber !== '';
  });
  return filteredWarranties;
};

const compressImage = () => {
  const compress = new Compress();

  // For photo
  compress
    .attach('#photo', {
      maxHeight: 1024,
      maxWidth: 1024,
    })
    .then((results) => {
      const img1 = results[0];
      const base64str = img1.data;
      const imgExt = img1.ext;
      compressedImage = Compress.convertBase64ToFile(base64str, imgExt);
    });

  // For photo02
  compress
    .attach('#photo-mall', {
      maxHeight: 1024,
      maxWidth: 1024,
    })
    .then((results) => {
      const img2 = results[0];
      const base64str = img2.data;
      const imgExt = img2.ext;
      compressedImage02 = Compress.convertBase64ToFile(base64str, imgExt);
    });
};

const clearExchangeStoreNameDropDown = () => {
  document.querySelector(
    "select[name='exchangeStoreNameDropdown']"
  ).required = false;
  document.querySelector('#exchangeStoreNameDropdownContainer').style.display =
    'none';
};

const clearPurchaseDate = () => {
  document.querySelector("input[name='purchaseDate']").required = false;
  document.querySelector('#purchaseDateContainer input').value = '';
  document.querySelector('#purchaseDateContainer').style.display = 'none';
};

const clearStoreName = () => {
  document.querySelector("input[name='storeName']").required = false;
  document.querySelector('#storeNameContainer input').value = '';
  document.querySelector('#storeNameContainer').style.display = 'none';
};

const clearStoreNameDropdown = () => {
  document.querySelector("select[name='storeNameDropdown']").required = false;
  document.querySelector('#storeNameDropdownContainer').style.display = 'none';
};

const clearUseDate = () => {
  document.querySelector("input[name='useStartDate']").required = false;
  document.querySelector('#giftStartDateContainer input').value = '';
  document.querySelector('#giftStartDateContainer').style.display = 'none';
};

const clearPhotoUpload = () => {
  document.querySelector('input[name="photo"]').required = false;
  document.querySelector('#photoUploadContainer input').value = '';
  document.querySelector('#photoUploadContainer').style.display = 'none';
};
const clearPhotoUpload02 = () => {
  document.querySelector(
    '#photoUploadContainer02 input[name="photo-mall"]'
  ).required = false;
  document.querySelector('#photoUploadContainer02 input').value = '';
  document.querySelector('#photoUploadContainer02').style.display = 'none';
};

const requireOrderNumber = () => {
  document.querySelector("input[name='orderNumber']").required = true;
  document.querySelector('#orderNumberContainer').style.display = 'block';
};

const clearOrderNumber = () => {
  document.querySelector("input[name='orderNumber']").required = false;
  document.querySelector('#orderNumberContainer input').value = '';
  document.querySelector('#orderNumberContainer').style.display = 'none';
};

const requireUseDate = () => {
  document.querySelector("input[name='useStartDate']").required = true;
  document.querySelector('#giftStartDateContainer').style.display = 'block';
};

const requirePurchaseDate = () => {
  document.querySelector("input[name='purchaseDate']").required = true;
  document.querySelector('#purchaseDateContainer').style.display = 'block';
};

const requirePhoto = () => {
  document.querySelector('input[name="photo"]').required = true;
  document.querySelector('#photoUploadContainer').style.display = 'block';
};

const requirePhoto02 = () => {
  document.querySelector('input[name="photo-mall"]').required = true;
  document.querySelector('#photoUploadContainer02').style.display = 'block';
};

const displayQuantity = (quantity) => {
  let n = 2;
  while (n <= quantity) {
    document.querySelector(`input[name='sku${n}']`).required = true;
    document.querySelector(`input[name='serialNumber${n}']`).required = true;
    document.querySelector(`#sku${n}Container`).style.display = 'block';
    n++;
  }
  if (quantity != 5) {
    for (let i = parseInt(quantity) + 1; i <= 5; i++) {
      document.querySelector(`#sku${i}Container input`).value = '';
      document.querySelector(`input[name='sku${i}']`).required = false;
      document.querySelector(`input[name='serialNumber${i}']`).required = false;
      document.querySelector(`#sku${i}Container`).style.display = 'none';
    }
  }
};

const requireStoreNameDropdown = () => {
  const storeNameDropdown = document.querySelector(
    'select[name="storeNameDropdown"]'
  );
  storeNameDropdown.required = true;
  const storeNameDropdownContainer = document.querySelector(
    '#storeNameDropdownContainer'
  );
  storeNameDropdownContainer.style.display = 'block';
};

const requireExchangeStoreNameDropDown = () => {
  const exchabgeStoreNameDropdown = document.querySelector(
    "select[name='exchangeStoreNameDropdown']"
  );
  exchabgeStoreNameDropdown.required = true;
  document.querySelector('#exchangeStoreNameDropdownContainer').style.display =
    'block';
};

const requireStoreName = () => {
  const storeNameInput = document.querySelector('input[name="storeName"]');
  storeNameInput.required = true;
  const storeNameContainer = document.querySelector('#storeNameContainer');
  storeNameContainer.style.display = 'block';
};

function openFirstTab() {
  if (localStorage.getItem('redirected') === 'true') {
    var firstExpandItem = document.querySelector('.expand-item:first-child');
    if (firstExpandItem) {
      firstExpandItem.click();
    }
    localStorage.removeItem('redirected');
  }
}
